import PageHero from "@/components/shared/PageHero";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import CTASection from "@/components/sections/CTASection";
import { ASSETS, BRAND } from "@/lib/brand";

export default function TestimonialsPage() {
  return (
    <div data-testid="page-testimonials">
      <PageHero
        eyebrow="Testimonials"
        title={<>In their <span className="italic text-bronze">own words.</span></>}
        sub="There's no higher compliment than a client telling their friends about you. Here is what a few of mine have said."
        image={ASSETS.portraits.formal}
        ctas={[
          { label: "Speak With Kiap", href: BRAND.whatsapp, variant: "primary" },
          { label: "See Proven Results", to: "/success-stories/proven-results", variant: "secondary" },
        ]}
      />
      <TestimonialsSection withHeading={false} />
      <CTASection />
    </div>
  );
}
